/* DO NOT OPEN site (Mail Night is the game in the box). No libraries. */
(function () {
  "use strict";

  /* Facts only Adam or real data can confirm. Fill these in and every spot on the page updates.
     While a fact is null, the line that needs it is hidden instead of showing a placeholder.
     Open the page with ?draft to see where each hidden fact would go. */
  var FACTS = {
    parcels: null,      // e.g. 14
    products: null,     // e.g. 3
    shipDays: null,     // e.g. "2–4"
    capacity: null,     // e.g. 100
    extra: null,        // e.g. "expansion deck"
    sourcing: null,     // e.g. "from carrier and retailer auctions"
    orderBy: null,      // e.g. "Monday"
    arriveBy: null,     // e.g. "Friday, Dec 4"
    email: null,        // e.g. "hello@mailnight.com"
    legalName: null,
    // Adam's real weekly screening counts, e.g. { vapes: 14, batteries: 9, blades: 3, letters: 22 }
    screened: null,
    // true only once Adam confirms banned-item screening in writing; until then those lines stay hidden
    screening: false
  };
  var DROP_AT = new Date("2026-11-27T20:00:00-05:00"); // orders open, 8pm ET
  // When people can actually buy. Before this, every buy button becomes "Get first access".
  // Move it earlier (e.g. Nov 10) only if the waitlist gets real checkout before the drop.
  var ORDERS_OPEN = DROP_AT;
  // Shop Pay Installments is only offered to US-based merchants. Turn on once the store qualifies.
  var PAY_IN_4 = false;

  // In Shopify, sections/mn-landing.liquid passes its theme-editor settings here.
  // Without it (the standalone v2 prototype), forms and the cart stay demo-only.
  var SHOP = window.MN_SETTINGS || null;
  if (SHOP) {
    Object.keys(SHOP.facts || {}).forEach(function (k) {
      var v = SHOP.facts[k];
      if (v !== "" && v !== null && v !== undefined) FACTS[k] = v;
    });
    if (SHOP.dropAt && !isNaN(new Date(SHOP.dropAt))) DROP_AT = new Date(SHOP.dropAt);
    ORDERS_OPEN = SHOP.ordersOpen && !isNaN(new Date(SHOP.ordersOpen)) ? new Date(SHOP.ordersOpen) : DROP_AT;
    PAY_IN_4 = !!SHOP.payIn4;
  }
  // Script-written messages; Shopify passes edited wording from Theme settings › Page text
  var C = (SHOP && SHOP.copy) || {};
  var KLAVIYO = SHOP && SHOP.klaviyo && SHOP.klaviyo.key && SHOP.klaviyo.list ? SHOP.klaviyo : null;
  var KLAVIYO_REVISION = "2024-10-15";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var draft = document.documentElement.classList.contains("draft");
  var has = function (k) { var v = FACTS[k]; return v !== null && v !== undefined && v !== "" && v !== false; };

  /* ---------- Tracking: one helper, three destinations, each only if present ----------
     In Shopify: Shopify.analytics.publish feeds a custom pixel; Klaviyo and Clarity load in the theme
     and only run after consent (Customer Privacy API). */
  var cartAttrs = { _mn_entry: "", _mn_role: "", _mn_score: "", _mn_guests: "" };
  function mnTrack(name, props) {
    props = props || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, props); } catch (e) {}
    try { if (window.klaviyo && klaviyo.track) klaviyo.track(name, props); } catch (e) {}
    try { if (typeof window.clarity === "function") window.clarity("event", name); } catch (e) {}
    if (draft && window.console) console.log("[mnTrack]", name, props);
  }

  /* ---------- Facts ---------- */
  $$("[data-fact]").forEach(function (el) {
    if (!has(el.dataset.fact)) return;
    el.textContent = (el.dataset.tpl || "{v}").replace("{v}", FACTS[el.dataset.fact]);
    el.classList.add("is-set");
  });
  // Lines that need a fact are hidden until it exists (shown outlined in ?draft mode)
  $$("[data-row], [data-needs]").forEach(function (el) {
    var k = el.dataset.row || el.dataset.needs;
    if (has(k)) return;
    if (draft) el.classList.add("is-missing"); else el.hidden = true;
  });
  $$("[data-needs-not]").forEach(function (el) { if (has(el.dataset.needsNot)) el.hidden = true; });
  if (has("email")) $$("[data-fact-href=email]").forEach(function (a) { a.href = "mailto:" + FACTS.email; });
  if (PAY_IN_4) $$("[data-payin4]").forEach(function (el) { el.hidden = false; });

  /* ---------- Countdown (days, hours, minutes: a real time, no ticking seconds) ---------- */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  var short = $("[data-countdown-short]"), big = $("[data-countdown]");
  function tick() {
    var ms = DROP_AT - Date.now();
    if (ms <= 0) {
      if (short) short.parentNode.textContent = "Orders are open";
      if (big) big.innerHTML = "<span>Open now</span>";
      return;
    }
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s / 3600) % 24, m = Math.floor(s / 60) % 60;
    if (short) short.textContent = d + "d " + h + "h " + pad(m) + "m";
    if (big) { $("[data-d]", big).textContent = d; $("[data-h]", big).textContent = pad(h); $("[data-m]", big).textContent = pad(m); }
  }
  tick(); setInterval(tick, 30000);

  /* ---------- Add the drop to a calendar (.ics) ---------- */
  // Inside an embedded viewer (an iframe), downloads and the share sheet are blocked, so copy instead
  var embedded = window.self !== window.top;
  function copyText(text) {
    if (!navigator.clipboard) return Promise.reject();
    return navigator.clipboard.writeText(text);
  }
  var ics = $("[data-ics]");
  if (ics) ics.addEventListener("click", function () {
    if (embedded) {
      var line = "DO NOT OPEN: orders open Fri Nov 27, 8pm ET. " + location.href.split("#")[0];
      copyText(line).then(function () { ics.textContent = "Copied. Paste it into your calendar: Fri Nov 27, 8pm ET"; },
        function () { ics.textContent = "Fri Nov 27, 8pm ET. Add it to your calendar."; });
      mnTrack("mn_calendar_added", { method: "copy" });
      return;
    }
    var start = DROP_AT.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
    var end = new Date(DROP_AT.getTime() + 30 * 60000).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
    var body = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//DO NOT OPEN//Orders//EN", "BEGIN:VEVENT",
      "UID:orders-open@donotopen", "DTSTAMP:" + start, "DTSTART:" + start, "DTEND:" + end,
      "SUMMARY:DO NOT OPEN: orders open", "DESCRIPTION:" + location.href.split("#")[0],
      "URL:" + location.href.split("#")[0], "BEGIN:VALARM", "TRIGGER:-PT15M", "ACTION:DISPLAY",
      "DESCRIPTION:Orders open in 15 minutes", "END:VALARM", "END:VEVENT", "END:VCALENDAR"].join("\r\n");
    var a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([body], { type: "text/calendar" }));
    a.download = "do-not-open-orders-open.ics";
    document.body.appendChild(a); a.click(); a.remove();
    mnTrack("mn_calendar_added", {});
  });

  /* ---------- Moments row ---------- */
  var row = $("[data-moments]"), bar = $("[data-progress]");
  if (row) {
    var prog = function () {
      var max = row.scrollWidth - row.clientWidth;
      var vis = row.clientWidth / row.scrollWidth;
      bar.style.width = Math.max(vis, max > 0 ? vis + (1 - vis) * (row.scrollLeft / max) : 1) * 100 + "%";
    };
    row.addEventListener("scroll", prog, { passive: true });
    window.addEventListener("resize", prog);
    prog();
    $$("[data-scroll]").forEach(function (b) {
      b.addEventListener("click", function () { row.scrollBy({ left: +b.dataset.scroll * 332, behavior: "smooth" }); });
    });
  }

  /* ---------- Play a round ---------- */
  var POOL = [
    { name: "A phone case for a phone nobody owns", cat: "dud", line: "Fits a model discontinued in 2014." },
    { name: "A cast-iron skillet, still boxed", cat: "useful", line: "Heavy enough to count as a workout." },
    { name: "Forty identical novelty socks", cat: "weird", line: "All of them have the same moose on." },
    { name: "A karaoke songbook, no machine included", cat: "weird", line: "Every song is from 1998." },
    { name: "Belts for an unknown vacuum", cat: "dud", line: "Somewhere, a vacuum is waiting." },
    { name: "A brand-new yoga mat", cat: "useful", line: "Still smells like the factory." }
  ];
  var CAT = { useful: "Useful", weird: "Weird", dud: "A dud" };
  var ROLE = { forecaster: "The Forecaster", thief: "The Thief", skeptic: "The Skeptic" };
  var game = $("[data-game]");
  if (game) {
    var st, steps = $$(".sheet__steps li", game);
    var show = function (name) {
      $$("[data-stage]", game).forEach(function (s) { s.hidden = s.dataset.stage !== name; });
      var idx = { role: 0, guess: 1, open: 2, verdict: 3, end: 4 }[name];
      steps.forEach(function (li, i) { li.classList.toggle("on", i <= idx); });
    };
    var tally = function (pop) {
      $("[data-t-role]", game).textContent = st.role ? ROLE[st.role] : "Not drawn yet";
      $("[data-t-opened]", game).textContent = st.opened + " of 3";
      var sc = $("[data-t-score]", game);
      sc.innerHTML = pop ? '<span class="score-pop">' + st.score + "</span>" : st.score;
    };
    var plays = 0;
    var reset = function () {
      var pool = POOL.slice().sort(function () { return Math.random() - .5; });
      st = { role: null, parcels: pool.slice(0, 3), i: 0, opened: 0, score: 0, guess: null, hits: 0, t0: 0 };
      // Roles are shuffled, so the card you tap is luck of the draw
      var faces = $$(".role", game).map(function (r) { return { role: r.dataset.role, html: $(".face", r).innerHTML }; })
        .sort(function () { return Math.random() - .5; });
      $$(".role", game).forEach(function (r, i) {
        r.classList.remove("flipped"); r.disabled = false;
        r.dataset.role = faces[i].role; $(".face", r).innerHTML = faces[i].html;
      });
      $("[data-role-note]", game).textContent = "Tap a card. Whatever you draw, you're stuck with it.";
      $$(".choice", game).forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
      show("role"); tally(false);
    };
    $$(".role", game).forEach(function (card) {
      card.addEventListener("click", function () {
        if (st.role) return;
        st.role = card.dataset.role; st.t0 = Date.now(); plays++;
        card.classList.add("flipped");
        $$(".role", game).forEach(function (r) { r.disabled = true; });
        $("[data-role-note]", game).textContent = "You're " + ROLE[st.role] + ". " + $(".face small", card).textContent;
        tally(true);
        mnTrack("mn_round_started", { role: st.role, plays: plays });
        // Long enough to read the card before the first parcel
        setTimeout(function () { $("[data-parcel-title]", game).textContent = "Parcel 1 of 3. What's inside?"; show("guess"); }, 1900);
      });
    });
    $$("[data-guess]", game).forEach(function (b) {
      b.addEventListener("click", function () {
        st.guess = b.dataset.guess;
        $$("[data-guess]", game).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        setTimeout(function () { $("[data-parcel]", game).classList.remove("open"); show("open"); }, 250);
      });
    });
    $("[data-parcel]", game).addEventListener("click", function () {
      var parcel = this;
      if (parcel.classList.contains("open")) return;
      parcel.classList.add("open");
      var p = st.parcels[st.i], hit = p.cat === st.guess, pts = 0;
      if (hit) pts = st.role === "forecaster" ? 4 : (st.role === "skeptic" && p.cat === "dud" ? 3 : 2);
      st.score += pts; st.opened++; if (hit) st.hits++;
      mnTrack("mn_parcel_opened", { index: st.i + 1, guess: st.guess, hit: hit });
      setTimeout(function () {
        $("[data-reveal]", game).innerHTML =
          '<span class="tag' + (hit ? " hit" : "") + '">' + CAT[p.cat] + (hit ? " · you called it, +" + pts : " · you guessed " + CAT[st.guess].toLowerCase() + ", +0") + "</span>" +
          "<b>" + p.name + "</b><span>" + p.line + "</span><small class=\"example\">Made-up example</small>";
        $$("[data-verdict]", game).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
        show("verdict"); tally(true);
      }, 700);
    });
    $$("[data-verdict]", game).forEach(function (b) {
      b.addEventListener("click", function () {
        var bonus = b.dataset.verdict === "keep" && st.role === "thief" ? 2 : 0;
        b.setAttribute("aria-pressed", "true");
        st.score += 1 + bonus;
        $("[data-role-note]", game).textContent = "";
        tally(true);
        st.i++;
        setTimeout(function () {
          $$("[data-guess]", game).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
          if (st.i < 3) {
            $("[data-parcel-title]", game).textContent = "Parcel " + (st.i + 1) + " of 3. What's inside? (+1 for every verdict" + (st.role === "thief" ? ", +2 more for every keep" : "") + ")";
            show("guess");
          } else {
            $("[data-end-title]", game).textContent = "You scored " + st.score + ".";
            $("[data-end-text]", game).textContent = "You called " + st.hits + " of 3. " + (C.roundEnd || "Now try it with up to 9 friends who steal.");
            cartAttrs._mn_role = st.role; cartAttrs._mn_score = String(st.score);
            mnTrack("mn_round_completed", { score: st.score, hits: st.hits, role: st.role, duration_s: Math.round((Date.now() - st.t0) / 1000), plays: plays });
            show("end");
          }
        }, 350);
      });
    });
    $("[data-replay]", game).addEventListener("click", function () { mnTrack("mn_round_replayed", { plays: plays }); reset(); });
    reset();
  }

  /* ---------- Group size: tabs, drawer and guests slider share one choice ---------- */
  var SIZES = {
    1: ["$249", C.size1 || "One box · about $25 a person for 10"],
    2: ["$498", C.size2 || "Two boxes · for 11 to 20 people"],
    3: ["$747", C.size3 || "Three boxes · for 21 to 30 people"]
  };
  var chosen = 1;
  function setSize(n, source) {
    chosen = n;
    $$("[data-tabs] [data-size]").forEach(function (t) { t.setAttribute("aria-selected", +t.dataset.size === n ? "true" : "false"); });
    var price = $("[data-box-price]");
    if (price) price.innerHTML = SIZES[n][0] + '<small data-box-sub>' + SIZES[n][1] + "</small>";
    var r = $("#o" + n); if (r) r.checked = true;
    var ap = $("[data-add-price]"); if (ap) ap.textContent = SIZES[n][0];
    if (source) mnTrack("mn_group_size_selected", { boxes: n, price: n * 249, source: source });
  }
  $$("[data-tabs] [data-size]").forEach(function (t) { t.addEventListener("click", function () { setSize(+t.dataset.size, "tabs"); }); });
  $$("[data-opts] input").forEach(function (r) { r.addEventListener("change", function () { setSize(+r.value, "drawer"); }); });

  var g = $("[data-guests]");
  if (g) {
    var boxesFor = function (n) { return n <= 10 ? 1 : n <= 20 ? 2 : 3; };
    var say = function () {
      var n = +g.value, boxes = boxesFor(n), total = boxes * 249;
      $("[data-guests-out]").textContent = n + " people";
      $("[data-guests-say]").textContent = (boxes === 1 ? "One box covers it. " : boxes + " boxes. ") + "$" + total + ", about $" + Math.round(total / n) + " a person.";
    };
    g.addEventListener("input", say);
    g.addEventListener("change", function () {
      var n = +g.value, boxes = boxesFor(n);
      cartAttrs._mn_guests = String(n);
      setSize(boxes, "slider");
      mnTrack("mn_guests_slider_set", { guests: n, boxes: boxes, total: boxes * 249 });
    });
    say();
  }

  /* ---------- Buy drawer, or first access before orders open ---------- */
  var soldOut = !!(SHOP && SHOP.soldOut) && Date.now() >= ORDERS_OPEN;
  var preDrop = Date.now() < ORDERS_OPEN || soldOut;
  var drawer = $("[data-drawer]"), lastFocus;
  if (preDrop) {
    $$("[data-buy]").forEach(function (b) { b.dataset.live = b.textContent; b.textContent = soldOut ? (C.soldoutButton || "Sold out. Get on the list") : (C.preButton || "Get first access"); });
    var track = $("[data-countdown-short]");
    if (track && soldOut) track.parentNode.textContent = C.soldoutNote || "Sold out for now. Get on the list for the next batch.";
    short = $("[data-countdown-short]"); tick();
  }
  function openDrawer(trigger) {
    lastFocus = document.activeElement;
    drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var c = $("#o" + chosen); if (c) c.focus();
    mnTrack("mn_buy_drawer_opened", { trigger: trigger, boxes_preset: chosen });
  }
  function closeDrawer() {
    drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }
  $$("[data-buy]").forEach(function (b) {
    b.addEventListener("click", function () {
      var trigger = b.dataset.buy || "other";
      cartAttrs._mn_entry = trigger;
      if (preDrop) {
        mnTrack("mn_first_access_clicked", { trigger: trigger });
        var dropSec = $("#drop"); dropSec.scrollIntoView({ behavior: "smooth", block: "start" });
        setTimeout(function () { $("#su-email").focus({ preventScroll: true }); }, 600);
        return;
      }
      openDrawer(trigger);
    });
  });
  $$("[data-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer.classList.contains("open")) closeDrawer(); });
  $("[data-add]").addEventListener("click", function () {
    var btn = this, err = $("[data-add-err]");
    var s = $("[data-added]"); s.classList.remove("on"); void s.offsetWidth; s.classList.add("on");
    mnTrack("mn_add_to_cart", { boxes: chosen, price: chosen * 249, attributes: cartAttrs });
    if (!SHOP || !SHOP.variantId) return; // prototype: the stamp only
    var json = { "Content-Type": "application/json", "Accept": "application/json" };
    btn.disabled = true; if (err) err.textContent = "";
    fetch("/cart/add.js", { method: "POST", headers: json, body: JSON.stringify({ items: [{ id: SHOP.variantId, quantity: chosen }] }) })
      .then(function (r) { if (!r.ok) throw new Error("add"); return fetch("/cart/update.js", { method: "POST", headers: json, body: JSON.stringify({ attributes: cartAttrs }) }); })
      .then(function () { location.href = "/checkout"; })
      .catch(function () {
        btn.disabled = false;
        if (err) err.textContent = "That didn't go through. It may have just sold out. Refresh and try again.";
      });
  });

  /* ---------- Sticky buy bar: only when no other buy button, team section or signup is on screen ---------- */
  var buybar = $("[data-buybar]"), hero = $(".hero");
  if ("IntersectionObserver" in window && buybar) {
    var pastHero = false, blockers = new Set();
    var upd = function () { buybar.classList.toggle("show", pastHero && blockers.size === 0); };
    new IntersectionObserver(function (e) {
      pastHero = !e[0].isIntersecting;
      hero.classList.toggle("off", !e[0].isIntersecting); // pauses the hero drift off screen
      upd();
    }).observe(hero);
    var bio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) blockers.add(e.target); else blockers.delete(e.target); });
      upd();
    });
    $$("[data-buy]").forEach(function (b) { if (!b.closest("[data-buybar], [data-drawer], .hero")) bio.observe(b); });
    $$("[data-bar-hide], .close").forEach(function (el) { bio.observe(el); });
  }

  /* ---------- Forms (prototype: Klaviyo and draft orders in Shopify) ---------- */
  function toE164(raw) {
    var d = raw.replace(/[^\d+]/g, "");
    if (/^\+\d{10,15}$/.test(d)) return d;
    d = d.replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d[0] === "1") return "+" + d;
    return null;
  }
  // Klaviyo client subscriptions API: email consent, plus SMS consent only when the box is ticked
  function klaviyoSubscribe(email, phone, source) {
    var attrs = { email: email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } };
    if (phone) { attrs.phone_number = phone; attrs.subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } }; }
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(KLAVIYO.key), {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", "Accept": "application/vnd.api+json", "revision": KLAVIYO_REVISION },
      body: JSON.stringify({ data: { type: "subscription", attributes: { custom_source: source, profile: { data: { type: "profile", attributes: attrs } } },
        relationships: { list: { data: { type: "list", id: KLAVIYO.list } } } } })
    }).then(function (r) { if (!r.ok) throw new Error("klaviyo"); });
  }

  // Shopify renders these as real customer / contact forms; the prototype marks them with data attributes
  var form = $("[data-signup]") || $("#mn-signup");
  if (form) {
    form.noValidate = true;
    form.addEventListener("submit", function (e) {
      var err = $(".err", form), em = $("#su-email"), ph = $("#su-phone"), sms = $("#su-sms");
      var phoneRaw = ph ? ph.value.trim() : "", e164 = phoneRaw ? toE164(phoneRaw) : null;
      var stop = function (msg, reason) { e.preventDefault(); err.textContent = msg; mnTrack("mn_signup_error", { reason: reason }); };
      if (!em.value.trim() || !em.validity.valid) return stop("Add a valid email.", "email");
      if (phoneRaw && !e164) return stop("Check the phone number. US numbers only.", "phone");
      if (phoneRaw && sms && !sms.checked) return stop("Tick the text box to get texts, or clear the phone number.", "sms_box");
      err.textContent = "";
      var smsOk = !!(phoneRaw && sms && sms.checked);
      mnTrack("mn_signup_submitted", { sms_opt_in: smsOk, location: "close" });
      if (KLAVIYO) {
        e.preventDefault();
        klaviyoSubscribe(em.value.trim(), smsOk ? e164 : null, "Website - close").then(function () {
          form.classList.add("done"); $(".ok", form).focus();
        }, function () { err.textContent = "That didn't go through. Try again in a minute."; });
        return;
      }
      if (SHOP) return; // native Shopify customer form: the page reloads with a thank-you
      e.preventDefault(); form.classList.add("done"); $(".ok", form).focus();
    });
  }
  $$("[data-mini], #mn-team, #mn-rolecard").forEach(function (f) {
    var kind = f.dataset.mini || (f.id === "mn-team" ? "team_inquiry" : "role_card");
    f.noValidate = true;
    f.addEventListener("submit", function (e) {
      var err = $(".mini-form__err", f), bad = $$("input[required]", f).filter(function (i) { return !i.value.trim() || !i.validity.valid; })[0];
      if (bad) {
        e.preventDefault();
        var lbl = bad.closest("label");
        err.textContent = bad.type === "email" ? "Add a valid email." : "Fill in the " + (lbl ? lbl.firstChild.textContent.trim().toLowerCase() : "missing field") + ".";
        bad.focus(); return;
      }
      err.textContent = "";
      var data = {}; $$("input, select", f).forEach(function (i) { if (i.type !== "email" && i.type !== "hidden") data[i.name] = i.value; });
      mnTrack(kind === "team_inquiry" ? "mn_team_inquiry" : "mn_role_card_requested", kind === "team_inquiry" ? data : { role: cartAttrs._mn_role, score: cartAttrs._mn_score });
      if (kind === "role_card" && KLAVIYO) {
        e.preventDefault();
        klaviyoSubscribe($("input[type=email]", f).value.trim(), null, "Website - role card").then(function () {
          f.classList.add("done"); $(".mini-form__ok", f).focus();
        }, function () { err.textContent = "That didn't go through. Try again in a minute."; });
        return;
      }
      if (SHOP) return; // native Shopify form submit (contact form emails the store; customer form saves the signup)
      e.preventDefault(); f.classList.add("done"); $(".mini-form__ok", f).focus();
    });
  });

  /* ---------- Screened out this week (only with Adam's real counts) ---------- */
  var scr = $("[data-screened]");
  if (scr && has("screened")) {
    var c = FACTS.screened, parts = [];
    if (c.vapes) parts.push(c.vapes + " vapes");
    if (c.batteries) parts.push(c.batteries + " lithium batteries");
    if (c.blades) parts.push(c.blades + " blades");
    if (c.letters) parts.push(c.letters + " personal letters set aside");
    scr.textContent = parts.join(" · ") + ".";
  }

  /* ---------- Skeptic button: proof first ---------- */
  var proof = $("#proof-first"), moved = [];
  var proofParts = ["#promises", ".never", "#notes"];
  function proofOn() {
    if (!proof.hidden) return;
    proofParts.forEach(function (sel) {
      var el = $(sel); if (!el) return;
      moved.push({ el: el, parent: el.parentNode, next: el.nextSibling });
      proof.appendChild(el);
    });
    proof.hidden = false;
    $$("[data-in]", proof).forEach(function (el) { el.classList.add("in"); });
    setTimeout(function () {
      proof.scrollIntoView({ behavior: "smooth", block: "start" });
      // Moving focus during a smooth scroll cancels it, so wait until it lands
      setTimeout(function () { $("[data-skeptic-off]").focus({ preventScroll: true }); }, 900);
    }, 0);
    mnTrack("mn_skeptic_mode", { on: true });
  }
  function proofOff() {
    moved.reverse().forEach(function (m) { m.parent.insertBefore(m.el, m.next); });
    moved = []; proof.hidden = true;
    $("[data-skeptic]").focus();
    mnTrack("mn_skeptic_mode", { on: false });
  }
  $$("[data-skeptic]").forEach(function (b) { b.addEventListener("click", proofOn); });
  $$("[data-skeptic-off]").forEach(function (b) { b.addEventListener("click", proofOff); });

  /* ---------- Send it to the group chat: message + picture ---------- */
  function partyPlan() {
    var n = g ? +g.value : 10, boxes = n <= 10 ? 1 : n <= 20 ? 2 : 3, total = boxes * 249;
    var d = $("[data-party-date]"), when = "";
    if (d && d.value) {
      var dt = new Date(d.value + "T12:00:00");
      when = dt.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
      cartAttrs._mn_party_date = d.value;
    }
    return { n: n, boxes: boxes, each: Math.round(total / n), when: when };
  }
  function partyImage(pl) {
    var W = 1080, H = 1350, cv = document.createElement("canvas"); cv.width = W; cv.height = H;
    var x = cv.getContext("2d");
    x.fillStyle = "#C8A97E"; x.fillRect(0, 0, W, H);
    x.fillStyle = "#F6F1E7"; x.fillRect(90, 120, W - 180, H - 240);
    x.fillStyle = "#141414";
    for (var i = 0; i < 3; i++) x.fillRect(150, 240 + i * 46, [420, 560, 330][i], 26); // redacted address
    x.font = '30px "Courier Prime", monospace'; x.fillText("DO NOT OPEN", 150, 400);
    x.font = '230px "Bebas Neue", Impact, sans-serif'; x.fillText("MAIL", 140, 640); x.fillText("NIGHT", 140, 840);
    x.font = '600 50px Inter, sans-serif';
    x.fillText(pl.when ? pl.when + " · at mine" : "At mine, soon", 150, 940);
    x.fillText(pl.n + " of us · about $" + pl.each + " each", 150, 1010);
    x.fillStyle = "#D7263D"; x.fillRect(150, 1060, 300, 100);
    x.fillStyle = "#fff"; x.font = '72px "Bebas Neue", Impact, sans-serif'; x.fillText("IN?", 255, 1135);
    x.fillStyle = "#141414"; x.font = '26px "Courier Prime", monospace';
    x.fillText("A party game made from lost mail. " + location.host, 150, 1205);
    return new Promise(function (res) { cv.toBlob(res, "image/png"); });
  }
  $$("[data-share-group]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var pl = partyPlan(), url = location.href.split("#")[0].split("?")[0];
      var text = "Mail Night at mine" + (pl.when ? " on " + pl.when : "") + "? Real lost mail + a party game. " +
        pl.n + " of us is about $" + pl.each + " each. In? " + url;
      var note = $("[data-share-note]");
      mnTrack("mn_group_share", { guests: pl.n, boxes: pl.boxes, has_date: !!pl.when });
      // Copy first, inside the click, while the browser still allows it
      var copied = copyText(text).then(function () { return true; }, function () { return false; });
      // Fallback: show the picture on the page to save, and the message to copy
      var showHere = function (blob) {
        var box = btn.parentNode.querySelector("[data-share-preview]");
        if (!box) { box = document.createElement("div"); box.className = "share-preview"; box.setAttribute("data-share-preview", ""); btn.insertAdjacentElement("afterend", box); }
        box.innerHTML = "";
        if (blob) { var im = document.createElement("img"); im.alt = "Mail Night invite picture for the group chat"; im.src = URL.createObjectURL(blob); box.appendChild(im); }
        var ta = document.createElement("textarea"); ta.readOnly = true; ta.value = text; ta.rows = 3; ta.setAttribute("aria-label", "Message for the group chat");
        box.appendChild(ta);
        copied.then(function (ok) {
          var msg = ok ? "Message copied. Press and hold the picture to save it." : "Select the message to copy it. Press and hold the picture to save it.";
          if (note && btn.closest(".share")) note.textContent = msg;
          var p = document.createElement("p"); p.className = "note mb0"; p.textContent = msg; box.appendChild(p);
          if (!ok) ta.select();
        });
      };
      document.fonts.load('80px "Bebas Neue"').then(function () { return partyImage(pl); }).then(function (blob) {
        var file = blob && window.File ? new File([blob], "mail-night-party.png", { type: "image/png" }) : null;
        var share = !embedded && navigator.share
          ? (file && navigator.canShare && navigator.canShare({ files: [file] }) ? navigator.share({ files: [file], text: text }) : navigator.share({ text: text }))
          : Promise.reject(new Error("no share"));
        return share.catch(function (err) {
          // The person closing the share sheet is not a failure
          if (err && err.name === "AbortError") return;
          showHere(blob);
        });
      }).catch(function () { showHere(null); });
    });
  });

  /* ---------- What stopped you? One tap, once, only after the visitor has seen the price ---------- */
  var stopped = $("[data-stopped]");
  if (stopped && "IntersectionObserver" in window) {
    var seen = false; try { seen = sessionStorage.getItem("mn_stopped") === "1"; } catch (e) {}
    var sawPrice = false, deepest = 0, armed = false;
    new IntersectionObserver(function (e) { if (e[0].isIntersecting) sawPrice = true; }).observe($("#menu"));
    var ask = function () {
      if (seen || armed || drawer.classList.contains("open")) return;
      armed = true; stopped.hidden = false; mnTrack("mn_stopped_shown", {});
    };
    window.addEventListener("scroll", function () {
      var y = window.scrollY; deepest = Math.max(deepest, y);
      // Heading back up a long way after seeing the price usually means "not yet"
      if (sawPrice && deepest - y > 1400) ask();
    }, { passive: true });
    var done = function () { seen = true; try { sessionStorage.setItem("mn_stopped", "1"); } catch (e) {} };
    $$("[data-reason]", stopped).forEach(function (b) {
      b.addEventListener("click", function () {
        mnTrack("mn_stopped_reason", { reason: b.dataset.reason });
        $(".stopped__opts", stopped).hidden = true; $(".stopped__ok", stopped).hidden = false; done();
        setTimeout(function () { stopped.hidden = true; }, 2200);
      });
    });
    $("[data-stopped-x]", stopped).addEventListener("click", function () { stopped.hidden = true; done(); mnTrack("mn_stopped_dismissed", {}); });
  }

  /* ---------- Entrances ---------- */
  var ins = $$("[data-in]");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -10% 0px" });
    ins.forEach(function (el) { io.observe(el); });
  } else ins.forEach(function (el) { el.classList.add("in"); });
})();
